import Home from './components/Home/Home';
import About from './components/About/About';
import NotFoundPage from './components/404Page/404Page';
import FormPage from './components/Form/FormPage';
import { InputProps } from './shared/Types';
import { Routes, Route } from 'react-router-dom';
import { Component } from 'react';

import './App.scss';

class App extends Component<InputProps> {
  constructor(props: InputProps) {
    super(props);
  }

  render() {
    return (
      <div className="App" data-testid="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/form" element={<FormPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    );
  }
}

export default App;
